module.exports = __webpack_public_path__ + "img/car.73b90fea.png";